async function hollyNotificationFetchData(url, options) {
    try {
        const response = await fetch(url, options);
        if(!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    }catch(error) {
        console.error('Error fetching data:', error);
        return null;
    }
}

function hollyNotificationValidateInput() {
    const email = document.getElementById("holly-email").value;
    const btn = document.getElementById("holly-notify-btn");
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(email)) {
        btn.classList.add("active");
        btn.disabled = false;
    } else {
        btn.classList.remove("active");
        btn.disabled = true;
    }
}
function formatPrice(amount) {

    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(amount);
}
const openHollyNotificationStockOutModal = async (button) => {

    const productID = button.getAttribute("data-product_id");
    const productVariantID = button.getAttribute("data-variant_id");
    const buttonType = button.getAttribute("data-button_type")
    const productPrice = button.getAttribute("data-product_price");
    const productUrl = button.getAttribute("data-product_url")
    if(!hollyCustomer){
        sessionStorage.setItem("hollyNotificationsProductVariantID", productVariantID)
        window.location.assign(`/account/login?return_url=${productUrl}`);
        return;
    }
    const hollyModal = document.getElementById('holly-modal')
    const buttonHtml = button.innerHTML;
    button.innerHTML = buttonType === "plp" ? `<span class="holly-loader"></span>` : `<span class="holly-xl-loader"></span>`
    const getCurrencySymbol = (currencyCode) => {
        const symbols = {
            "TRY": "₺",
            "EUR": "€",
            "USD": "$",
            "GBP": "£"
        };
        return symbols[currencyCode] || currencyCode;
    };
    const recomendedProducts = await hollyNotificationFetchProductRecommendations(`gid://shopify/Product/${productID}`)
    const recomendedProductsInStock =  (recomendedProducts || []).filter(product => product.totalInventory > 0 && !product.metafields[4]?.value )

    const carouselItemsHTML =
        (recomendedProductsInStock || []).map(product => `
        <div class="holly-carousel-item">
            <a href=${`/products/${product.handle}`} class="holly-modal-img-area">
               ${product.metafields[1]?.reference?.image?.url
                    ? `<img class="holly-modal-img-top-badge" src="${product.metafields[1].reference.image.url}" alt="${product.title} Sol Üst Badge" width="35" height="35" />`
                    : "" 
                }
                ${product.metafields[0]?.reference?.image?.url
            ? `<img class="holly-modal-img-bottom-badge" src="${product.metafields[0].reference.image.url}" alt="${product.title} Sağ Alt Badge" width="35" height="35" />`
            : ""
        }
                
              <img src="${product.featuredImage.src}" alt="${product.featuredImage.altText}"/>
               ${product.metafields[3]?.value
            ? `<p class="holly-palm-modal-campaign-text" >
                  ${product.metafields[3]?.value.replace(/["'\[\]]/g, '')}
               </p>`
            : "" }
   
            </a>
          
            <div class="holly-modal-product-info-area">
                <div class="holly-modal-product-title-area">
                    <p class="holly-modal-product-info-area-title">${product.title}</p>
                    <div class="holly-modal-product-info-price-area">
                        <div>
                        <div class="holly-modal-compare-price-area">
                        

                                 <p class="holly-modal-product-info-area-compare-price"> 
                                ${product.compareAtPriceRange.minVariantPrice.amount !== "0.0"
            ? `${product.compareAtPriceRange.minVariantPrice.amount} ${getCurrencySymbol(product.compareAtPriceRange.minVariantPrice.currencyCode)}`
            : ""}
                                            ${product.compareAtPriceRange.minVariantPrice.amount !== "0.0"
            ? `<p class="holly-modal-product-info-price-area-percentage">   
                                -${Math.floor(((product.compareAtPriceRange.minVariantPrice.amount - product.priceRange.minVariantPrice.amount) / product.compareAtPriceRange.minVariantPrice.amount) * 100)}%
                             </p>`
            : ""}</div>
                            </p>
                            <p class="holly-modal-product-info-area-selling-price">
                              
                                ${formatPrice(product.priceRange.minVariantPrice.amount)} 
                                TL
                            </p>
                      <p class="holly-modal-cart-price">
                      ${product.metafields[2]?.value
                                ? `Sepette ${
                          formatPrice(
                            product.priceRange.minVariantPrice.amount  - (() => {
                                        let discountedPrice = Number(
                                            product.priceRange.minVariantPrice.amount *
                                            product.metafields[2].value /
                                            100
                                        );
                                        let stringifiedPrice = discountedPrice.toString();
                                        let decimalIndex = stringifiedPrice.indexOf('.'); 
                                        let truncated = stringifiedPrice.slice(0, decimalIndex + 3); 
                                        return parseFloat(truncated).toFixed(2); 
                                    })()
                          )  } TL`
                                : ""}
                    </p>
                                       
                        </div>
            
                    </div>
                </div>
                <button 
                    data-product_handle="${product.handle}"  
                    data-product_variant_id="${product.selectedOrFirstAvailableVariant.id}" 
                    data-product_variant_count="${product.variantsCount.count}" 
                    onclick="hollyNotificationHandleAddToCart(this)" 
                    class="holly-modal-product-add-to-cart-btn">
          
                    ${product.variantsCount.count > 1 ? hollyViewProductText : hollyAddToCartText}
                </button>
            </div>
        </div>
    `).join('');

    if(hollyCustomerEmail) {
        const response = await hollyNotificationTrackAdd(productID,productVariantID, "InStock", hollyCustomerEmail, productPrice, hollyNotificationsCustomerID, hollyNotificationsCustomerName )

        const isSuccess = response?.succeeded;

        let carouselItemsAreaHTML = "";
        if (carouselItemsHTML.trim()) {
            carouselItemsAreaHTML = `
        <div class="holly-carousel-container ">
            <div>
                <p class="holly-modal-product-area-title"> ${hollySimilarProducts}</p>
            </div>
            <div id="holly-carousel">
                ${carouselItemsHTML}
            </div>
            <div class="holly-carousel-btn-area prev-btn">
             <button class="holly-carousel-button prev">
                <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2047_2)">
                        <path d="M8.41406 1.914L1.93006 8.4L0.515062 6.985L7.00006 0.5L8.41406 1.914Z" fill="black"/>
                        <path d="M6.98493 13.485L0.499926 6.99996L1.91393 5.58496L8.39893 12.071L6.98493 13.485Z" fill="black"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_2047_2">
                            <rect width="13" height="8" fill="white" transform="translate(8.5 0.5) rotate(90)"/>
                        </clipPath>
                    </defs>
                </svg>
            </button>
            </div>
           
            <div class="holly-carousel-btn-area next-btn">
               <button class="holly-carousel-button next">
                <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2047_2)">
                        <path d="M0.585938 12.086L7.06994 5.6L8.48494 7.015L1.99994 13.5L0.585938 12.086Z" fill="black"/>
                        <path d="M2.01507 0.515039L8.50007 7.00004L7.08607 8.41504L0.601074 1.92904L2.01507 0.515039Z" fill="black"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_2047_2">
                            <rect width="13" height="8" fill="white" transform="translate(0.5 13.5) rotate(-90)"/>
                        </clipPath>
                    </defs>
                </svg>
            </button>
            </div>
         
        </div>
            `;
        }
        if(isSuccess){
            hollyModal.innerHTML = `
              <div class="holly-modal-large-container" >
                <div id="holly-modal-content" style="gap: 20px;">
                <div class="holly-modal-header">
                  <div class="holly-modal-title-area">
                  <div class="holly-modal-title-icon">
                     <div style="
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            gap: 7px;
                            ">
                   
                         <p class="holly-modal-title" >${hollyMessagesSuccessfulScenarioTitle}</p>
                        </div>
                    </div>
                                <div class="holly-modal-divider"></div>
                            <div class="holly-modal-logo-area">
                                           <img  src="https://cdn.shopify.com/s/files/1/0598/6798/8046/files/Jumbo_Logo.png?v=1742908601" alt="Jumbo Logo" width="150" height="50"/> </div>
                    <p class="holly-modal-body">
                    ${hollyMessagesSuccessfulScenarioDesc}
                    </p>
                  </div>
                  <div class="holly-modal-close-btn" id="holly-modal-close">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19.0005 4.99988L5.00049 18.9999M5.00049 4.99988L19.0005 18.9999" stroke="#383838" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
    
               
                    ${carouselItemsAreaHTML}

                </div>
               </div>
     `;
        }else{
            hollyModal.innerHTML = `
              <div class="holly-modal-large-container" >
                <div id="holly-modal-content" style="gap: 20px;">
                <div class="holly-modal-header">
                  <div class="holly-modal-title-area">
                  <div class="holly-modal-title-icon">
                       
                         <p class="holly-modal-title" >${hollyMessagesFailedScenarioTitle}</p>
                    </div>
                          <div class="holly-modal-divider"></div>
                          <div class="holly-modal-logo-area">
                                           <img  src="https://cdn.shopify.com/s/files/1/0598/6798/8046/files/Jumbo_Logo.png?v=1742908601" alt="Jumbo Logo" width="150" height="50"/> </div>
                    <p class="holly-modal-body">
                            ${hollyMessagesFailedScenarioDesc}
                    </p>
                  </div>
                  <div class="holly-modal-close-btn" id="holly-modal-close">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19.0005 4.99988L5.00049 18.9999M5.00049 4.99988L19.0005 18.9999" stroke="#383838" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
              
                    ${carouselItemsAreaHTML}
                </div>
        
                </div>
               </div>
     `;
        }
        button.innerHTML = buttonHtml ;

    }else{
        hollyModal.innerHTML = `
     <div class="holly-modal-container" >
        <div id="holly-modal-content">
        <div class="holly-modal-header">
          <div class="holly-modal-title-area">
            <p class="holly-modal-title">${hollyMessagesGuestScenarioTitle}</p>
            <p class="holly-modal-body">
            ${hollyMessagesGuestScenarioDesc}
            </p>
          </div>
          <div class="holly-modal-close-btn" id="holly-modal-close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.0005 4.99988L5.00049 18.9999M5.00049 4.99988L19.0005 18.9999" stroke="#383838" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
        <div class="holly-modal-input-group">
          <div class="holly-modal-input">
            <label for="email">${hollyInputLabel}</label>
            <input type="email" id="holly-email" placeholder="${hollyInputLabel}" oninput="hollyNotificationValidateInput()">
          </div>

          <button class="holly-modal-btn" onclick="hollyNotificationAddStockNotification(this)" data-product_id=${productID}  
          id="holly-notify-btn" data-variant_id=${productVariantID} data-product_price=${productPrice} disabled>
              <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.79864 9.57555C4.73741 10.7389 4.8078 11.9772 3.76844 12.7567C3.2847 13.1195 3 13.6889 3 14.2936C3 15.1254 3.6515 15.833 4.5 15.833H16.5C17.3485 15.833 18 15.1254 18 14.2936C18 13.6889 17.7153 13.1195 17.2316 12.7567C16.1922 11.9772 16.2626 10.7389 16.2013 9.57555C16.0418 6.54324 13.5365 4.16638 10.5 4.16638C7.46347 4.16638 4.95823 6.54323 4.79864 9.57555Z" stroke="white" stroke-width="1.07143" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.25 2.60388C9.25 3.29424 9.80967 4.16638 10.5 4.16638C11.1903 4.16638 11.75 3.29424 11.75 2.60388C11.75 1.91352 11.1903 1.66638 10.5 1.66638C9.80967 1.66638 9.25 1.91352 9.25 2.60388Z" stroke="white" stroke-width="1.07143"/>
                <path d="M13 15.8336C13 17.2144 11.8807 18.3336 10.5 18.3336C9.11925 18.3336 8 17.2144 8 15.8336" stroke="white" stroke-width="1.07143" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            ${hollyNotifyMeText}
          </button>
        </div>
        </div>
       </div>
     `;
        document.body.style.overflow = "hidden";
        document.body.style.touchAction = "none";
        button.innerHTML = buttonHtml ;
    }

    hollyModal.classList.add('holly-open-modal');

    document.body.style.overflow = "hidden";
    document.body.style.touchAction = "none";

    const closeModalBtn = document.getElementById("holly-modal-close");
    function closeModal() {
        hollyModal.classList.remove('holly-open-modal');
        document.body.style.overflow = "";
        document.body.style.touchAction = "";
    }

    closeModalBtn.addEventListener("click", () => {
        closeModal();

    });
    hollyModal.addEventListener("click", (event) => {
        if (event.target === hollyModal) {
            closeModal();
        }
    });
    if(recomendedProductsInStock.length > 0){
        hollyNotificationInitCarousel(recomendedProductsInStock);
    }
}

const hollyNotificationHandleAddToCart = async (button) => {
    const hollyModal = document.getElementById('holly-modal')
    button.classList.add('holly-loading');
    button.innerHTML = `
<span class="holly-loader"></span>
  `;
    button.disabled = true;

    const shopifyID = button.getAttribute("data-product_variant_id");
    const productVariantCount = button.getAttribute("data-product_variant_count");
    const productHandle = button.getAttribute("data-product_handle");

    try {
        if (productVariantCount === "1") {
            const productID = shopifyID.split("/").pop();
            await hollyNotificationAddToCart(productID);

        } else if (productVariantCount > 1) {
            window.location.href = `/products/${productHandle}`;
        }
    } catch (error) {
        console.error('Error adding to cart:', error);
    } finally {
        hollyModal.classList.remove('holly-open-modal');
        document.body.style.overflow = "";
        document.body.style.touchAction = "";
        button.classList.remove('holly-loading');
        button.innerHTML = `
        ${productVariantCount > 1 ? hollyViewProductText : hollyAddToCartText}
    `;
        button.disabled = false;
    }
};

const hollyNotificationAddToCart = async (productId) => {
    const response = await hollyNotificationFetchData('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            id: productId,
            quantity: 1
        })
    })

    const event = new CustomEvent('holly-app-addtocart', {
        detail:  response,
    });
    window.dispatchEvent(event);
}

async function hollyNotificationHandleStockNotificationClick(response, productID) {
    const hollyModal = document.getElementById('holly-modal')
    hollyModal.classList.remove('holly-open-modal');
    document.body.style.overflow = "";
    const getCurrencySymbol = (currencyCode) => {
        const symbols = {
            "TRY": "₺",
            "EUR": "€",
            "USD": "$",
            "GBP": "£"
        };
        return symbols[currencyCode] || currencyCode;
    };
    const recomendedProducts = await hollyNotificationFetchProductRecommendations(`gid://shopify/Product/${productID}`)
    const recomendedProductsInStock =  (recomendedProducts || []).filter(product => product.totalInventory > 0)
    const carouselItemsHTML =
        (recomendedProductsInStock || []).map(product => `
        <div class="holly-carousel-item">
             <a href=${`/products/${product.handle}`}>
              <img src="${product.featuredImage.src}" alt="${product.featuredImage.altText}">
            </a>
            <div class="holly-modal-product-info-area">
                <div class="holly-modal-product-title-area">
                    <p class="holly-modal-product-info-area-title">${product.title}</p>
                    <div class="holly-modal-product-info-price-area">
                        <div>
                               <p class="holly-modal-product-info-area-compare-price"> 
                                ${product.compareAtPriceRange.minVariantPrice.amount !== "0.0"
            ? `${product.compareAtPriceRange.minVariantPrice.amount} ${getCurrencySymbol(product.compareAtPriceRange.minVariantPrice.currencyCode)}`
            : ""}
                            </p>
                            <p class="holly-modal-product-info-area-selling-price">
                                ${product.priceRange.minVariantPrice.amount} 
                                ${getCurrencySymbol(product.priceRange.minVariantPrice.currencyCode)}
                            </p>
                            
                     
                        </div>
                        ${product.compareAtPriceRange.minVariantPrice.amount !== "0.0"
            ? `<p class="holly-modal-product-info-price-area-percentage">   
                                -${Math.round(((product.compareAtPriceRange.minVariantPrice.amount - product.priceRange.minVariantPrice.amount) / product.compareAtPriceRange.minVariantPrice.amount) * 100)}%
                             </p>`
            : ""}
                    </div>
                </div>
                <button 
                    data-product_handle="${product.handle}"  
                    data-product_variant_id="${product.selectedOrFirstAvailableVariant.id}" 
                    data-product_variant_count="${product.variantsCount.count}" 
                    onclick="hollyNotificationHandleAddToCart(this)" 
                    class="holly-modal-product-add-to-cart-btn">
                    ${product.variantsCount.count  > 1 ? hollyViewProductText : hollyAddToCartText}
                </button>
            </div>
        </div>
    `).join('');
    const isSuccess = response?.succeeded;
    let carouselItemsAreaHTML = "";
    if (carouselItemsHTML.trim()) {
        carouselItemsAreaHTML = `
        <div class="holly-carousel-container  ">
            <div>
                <p class="holly-modal-product-area-title">${hollySimilarProducts}</p>
            </div>
            <div id="holly-carousel">
                ${carouselItemsHTML}
            </div>
                 <div class="holly-carousel-btn-area prev-btn">
            <button class="holly-carousel-button  prev">
                <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2047_2)">
                        <path d="M8.41406 1.914L1.93006 8.4L0.515062 6.985L7.00006 0.5L8.41406 1.914Z" fill="black"/>
                        <path d="M6.98493 13.485L0.499926 6.99996L1.91393 5.58496L8.39893 12.071L6.98493 13.485Z" fill="black"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_2047_2">
                            <rect width="13" height="8" fill="white" transform="translate(8.5 0.5) rotate(90)"/>
                        </clipPath>
                    </defs>
                </svg>
            </button>
            </div>
           <div class="holly-carousel-btn-area next-btn">
            <button class="holly-carousel-button  next">
                <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2047_2)">
                        <path d="M0.585938 12.086L7.06994 5.6L8.48494 7.015L1.99994 13.5L0.585938 12.086Z" fill="black"/>
                        <path d="M2.01507 0.515039L8.50007 7.00004L7.08607 8.41504L0.601074 1.92904L2.01507 0.515039Z" fill="black"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_2047_2">
                            <rect width="13" height="8" fill="white" transform="translate(0.5 13.5) rotate(-90)"/>
                        </clipPath>
                    </defs>
                </svg>
            </button>
            </div>
        </div>
    `;
    }
    if(isSuccess){
        hollyModal.innerHTML = `
              <div class="holly-modal-large-container" >
                <div id="holly-modal-content" style="gap: 20px;">
                <div class="holly-modal-header">
                  <div class="holly-modal-title-area">
                  <div class="holly-modal-title-icon">
                     <div style="
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            gap: 7px;">
                      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22.8008 12.999C22.8008 7.47617 18.3236 2.99902 12.8008 2.99902C7.27793 2.99902 2.80078 7.47617 2.80078 12.999C2.80078 18.5218 7.27793 22.999 12.8008 22.999C18.3236 22.999 22.8008 18.5218 22.8008 12.999Z" stroke="#06971E" stroke-width="1.5"/>
                        <path d="M8.53418 13.5334L11.2008 16.2L17.0675 9.80005" stroke="#06971E" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                       </svg>
                         <p class="holly-modal-title" style="color: #06971E;">${hollyMessagesSuccessfulScenarioTitle}</p>
                        </div>
                    </div>
                   <div class="holly-modal-divider"></div>
                    <p class="holly-modal-body">
                   ${hollyMessagesSuccessfulScenarioDesc}
                    </p>
                  </div>
                  <div class="holly-modal-close-btn" id="holly-modal-close">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19.0005 4.99988L5.00049 18.9999M5.00049 4.99988L19.0005 18.9999" stroke="#383838" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
             
                  ${carouselItemsAreaHTML}
        
                </div>
               </div>
     `;
    }else{
        hollyModal.innerHTML = `
              <div class="holly-modal-large-container" >
                <div id="holly-modal-content" style="gap: 20px;">
                <div class="holly-modal-header">
                  <div class="holly-modal-title-area">
                  <div class="holly-modal-title-icon">
                        <div style="
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            gap: 7px;">
                          <svg width="26" height="32" viewBox="0 0 26 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22.7998 16C22.7998 10.4771 18.3226 6 12.7998 6C7.27695 6 2.7998 10.4771 2.7998 16C2.7998 21.5228 7.27695 26 12.7998 26C18.3226 26 22.7998 21.5228 22.7998 16Z" stroke="#F7B501" stroke-width="1.5"/>
                            <path d="M13.042 21V16C13.042 15.5286 13.042 15.2929 12.8955 15.1464C12.7491 15 12.5134 15 12.042 15" stroke="#F7B501" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12.792 12H12.801" stroke="#F7B501" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    

                         <p class="holly-modal-title" >${hollyMessagesFailedScenarioTitle}</p>
                    </div>
                        
                    <p class="holly-modal-body">
                           ${hollyMessagesFailedScenarioDesc}
                    </p>
                  </div>
                  <div class="holly-modal-close-btn" id="holly-modal-close">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19.0005 4.99988L5.00049 18.9999M5.00049 4.99988L19.0005 18.9999" stroke="#383838" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
               
                  </div>
                </div>
                <div class="holly-modal-divider"></div>
                 ${carouselItemsAreaHTML}
                </div>
               </div>
     `;
    }

    hollyModal.classList.add('holly-open-modal');

    document.body.style.overflow = "hidden";
    document.body.style.touchAction = "none";


    const closeModalBtn = document.getElementById("holly-modal-close");

    function closeModal() {
        hollyModal.classList.remove('holly-open-modal');
        document.body.style.overflow = "";
        document.body.style.touchAction = "";

    }
    closeModalBtn.addEventListener("click", () => {
        closeModal();
    });
    hollyModal.addEventListener("click", (event) => {
        if (event.target === hollyModal) {
            closeModal();
        }
    });

    if(recomendedProductsInStock.length > 0){
        hollyNotificationInitCarousel(recomendedProductsInStock);
    }
}

const hollyNotificationTrackAdd = async(productID, productVariantId, trackingType, email, price, customerId, name  ) => {
    const response =  await hollyNotificationFetchData('https://shopify-dev-api.jumbo.com.tr/api/v1/customer/stock-request-notify', {
        method: 'POST',
        headers:  { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            "customerId": customerId ? customerId : null,
            "name": name ? name : null,
            "productId": productID,
            "productVariantId": productVariantId,
            "trackingType": trackingType,
            "email": email,
            "price": null,
             // comnexus payloadı
          "ShopifyProductVariantId": `gid://shopify/ProductVariant/${productVariantId}`,
          "Email": email
        })
    })

    return response;
}

const hollyNotificationAddStockNotification = async(button) => {
    const productID = button.getAttribute("data-product_id");
    const productVariantID = button.getAttribute("data-variant_id");
    const productPrice = button.getAttribute("data-product_price");
    const trackingType = "InStock"
    const customerEmail = document.getElementById("holly-email").value;
    button.classList.add('holly-loading');
    button.innerHTML = `<span class="holly-xl-loader"></span>`
    button.disabled = true;
    const response =  await hollyNotificationTrackAdd(productID,productVariantID, trackingType, customerEmail, productPrice, hollyNotificationsCustomerID, hollyNotificationsCustomerName )
    return hollyNotificationHandleStockNotificationClick(response, productID);

}

async function hollyNotificationFetchProductRecommendations(productId) {
    const query = `
       query productRecommendations($productId: ID!) {
  productRecommendations(productId: $productId) {
    id
    handle
    selectedOrFirstAvailableVariant {
      id
    }
    variantsCount {
      count
    }
    totalInventory
    priceRange {
      minVariantPrice {
        amount
        currencyCode
      }
    }
    compareAtPriceRange {
      minVariantPrice {
        amount
        currencyCode
      }
    }
    onlineStoreUrl
    title
    featuredImage {
      altText
      src
    }
    metafields(
      identifiers: [
        {key: "badge_image_bottom", namespace: "custom"}, 
        {key: "badge_image", namespace: "custom"}, 
        {key: "sepette_indirim_orani", namespace: "custom"}, 
        {key: "listeleme_badge", namespace: "custom"},
        {key: "closed_for_sale_new", namespace: "custom"}
      ]
    ) {
      reference {
        ... on MediaImage {
          image {
            url(transform: {maxHeight: 100, maxWidth: 100})
          }
        }
      }
      value
    }
  }
}
    `;

    const variables = { productId };
    if(hollyShopUrl) {
        try {
            const response = await fetch(`https://${hollyShopUrl}/api/2025-07/graphql.json`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': `faad31569ee4142cbb08f65383ca4749`,
                },
                body: JSON.stringify({ query, variables })
            });

            const result = await response.json();
            return result.data.productRecommendations;
        } catch (error) {
            console.error('Error fetching product recommendations:', error);
            return null;
        }
    }

}

const hollyNotificationInitCarousel = (productsIndex) => {
    const carousel = document.getElementById("holly-carousel");
    const prevBtnArea = document.querySelector(".holly-carousel-btn-area.prev-btn");
    const nextBtnArea = document.querySelector(".holly-carousel-btn-area.next-btn");
    const prevButton = document.querySelector('.holly-carousel-button.prev');
    const nextButton = document.querySelector('.holly-carousel-button.next');
    const currentItem = document.querySelector('.holly-carousel-item');
    let currentIndex = 0;
    const cardIndex = productsIndex.length;
    const gap = 12;

    let startX = 0;
    let endX = 0;
    const swipeThreshold = 50;
    const oneItemWidth = currentItem?.offsetWidth;

    const getVisibleItemsCount = () => {
        const width = window.innerWidth;
        if (width >= 647) {
            return 4;
        } else if (width >= 425) {
            return 3;
        } else {
            return 2;
        }
    };

    function updateCarousel() {
        const visibleItems = getVisibleItemsCount();
        const totalGap = (visibleItems - 1) * gap;
        const itemWidth = oneItemWidth * visibleItems + totalGap;
        const maxIndex = Math.max(0, cardIndex - visibleItems);


        currentIndex = Math.min(currentIndex, maxIndex);
        currentIndex = Math.max(currentIndex, 0);


        const offset = -currentIndex * (oneItemWidth + gap);
        carousel.style.transition = 'transform 0.5s ease';
        carousel.style.transform = `translateX(${offset}px)`;


        if (prevButton) prevButton.disabled = currentIndex === 0;
        if (nextButton) nextButton.disabled = currentIndex >= maxIndex;
    }


    prevBtnArea?.addEventListener('click', function() {
        if (currentIndex > 0) {
            currentIndex--;
            updateCarousel();
        }

    });

    nextBtnArea?.addEventListener('click', function() {
        if (currentIndex < cardIndex) {
            currentIndex++;
            updateCarousel();
        }

    });

    carousel?.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        endX = startX;
    });

    carousel?.addEventListener('touchmove', (e) => {
        endX = e.touches[0].clientX;
    });

    carousel?.addEventListener('touchend', () => {
        const deltaX = startX - endX;


        if (Math.abs(deltaX) < swipeThreshold) {
            return;
        }

        if (deltaX > 0 && currentIndex < cardIndex - getVisibleItemsCount()) {
            currentIndex++;
        } else if (deltaX < 0 && currentIndex > 0) {
            currentIndex--;
        }
        updateCarousel();
    });

    window.addEventListener('resize', updateCarousel);

    if(carousel){
        updateCarousel();
    }
};
